import { render, staticRenderFns } from "./AmazonLinkField.vue?vue&type=template&id=416173d0&"
import script from "./AmazonLinkField.vue?vue&type=script&lang=js&"
export * from "./AmazonLinkField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseField: require('/app/components/fields/BaseField.vue').default})
